var map = {
	"./LogoBotGaert.png": "0f06",
	"./andrcleaning.jpeg": "1161",
	"./blackwoodrfc.png": "9e77",
	"./breconrfc.jpeg": "402c",
	"./cardiffdevils.jpeg": "0bbd",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./niche.png": "cec8",
	"./scarlets.jpeg": "04a0",
	"./thrivinghive.png": "8411",
	"./thrivinghive.svg": "db0e",
	"./zipworld.jpg": "c0ca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";